import { isSameDay } from 'date-fns';
import styled from '@emotion/styled';
import { getDefaultTimeItem, timeOptions } from './options';
import {
	ITimeSelectProps,
	TimeSelect,
} from '../../../../components/common/time-select/TimeSelect';
import { MaybeDate } from '../../../../components/common/date-picker/MaybeDate';
import { MaybeTimeOption } from '../../../../components/common/time-select/TimeOption';
import { Css, Responsive } from '../../../../ui';

export interface IExitTimeSelectProps extends Omit<ITimeSelectProps, 'items'> {
	entryDate?: MaybeDate;
	entryTime?: MaybeTimeOption;
	exitDate?: MaybeDate;
}

export const ExitTimeSelect = ({
	entryDate,
	entryTime,
	exitDate,
	selectedItem,
	...rest
}: IExitTimeSelectProps) => {
	const filteredItems = getExitTimeOptions(entryDate, entryTime, exitDate);
	const defaultTimeItem = getDefaultTimeItem(
		filteredItems,
		selectedItem?.value,
	);

	return (
		<StyledTimeSelect
			placeholderAsLabel
			items={filteredItems}
			defaultScrollToNthItem={defaultTimeItem}
			selectedItem={selectedItem}
			{...rest}
		/>
	);
};

const StyledTimeSelect = styled(TimeSelect)`
	min-width: ${Css.pxToRem(240)};
	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		width: 100%;
	}
	grid-area: exittime;
`;

const getExitTimeOptions = (
	entryDate?: MaybeDate,
	entryTime?: MaybeTimeOption,
	exitDate?: MaybeDate,
) => {
	if (!entryDate || !exitDate || !entryTime) return timeOptions;

	if (!isSameDay(entryDate, exitDate)) return timeOptions;

	return timeOptions.filter(
		(timeOption) => timeOption.timeInMinutes > entryTime.timeInMinutes,
	);
};
